import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import api from '../../lib/api';
import { timeAgo } from '../categoryMeta';
import ToolHeader, { NoAccess, Spinner } from './ToolHeader';

export default function ReceivingListPage() {
  const { tools } = useOutletContext();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (tools?.receiving) api.get('/staff-app/receiving/orders').then((r) => setOrders(r.data.orders)).catch(() => setOrders([]));
  }, [tools]);

  if (tools && !tools.receiving) return <><ToolHeader title="Receive deliveries" /><NoAccess /></>;
  return (
    <div data-testid="staff-app-receiving-list">
      <ToolHeader title="Receive deliveries" subtitle="Approved purchase orders awaiting goods" />
      <div className="p-4 space-y-2">
        {!orders ? <Spinner /> : orders.length === 0 ? (
          <p className="py-12 text-center text-sm text-muted-foreground" data-testid="staff-app-receiving-empty">No purchase orders are waiting for delivery.</p>
        ) : orders.map((o) => (
          <button key={o.po_id} onClick={() => navigate(o.po_id)} data-testid={`staff-app-po-${o.po_id}`}
            className="staff-app-feed-item w-full flex items-center gap-3 rounded-xl border border-border bg-card px-3.5 py-3 text-left">
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold truncate">{o.supplier_name || 'Supplier'}</span>
              <span className="block text-xs text-muted-foreground truncate">{o.po_id} · {o.line_count} line(s) · {o.status === 'partial' ? 'Part received' : 'Approved'} · {timeAgo(o.created_at)}</span>
              {o.last_precheck && (
                <span className={`inline-block mt-1 text-[10px] font-bold px-1.5 py-0.5 rounded ${o.last_precheck.status === 'clean' ? 'bg-emerald-500/15 text-emerald-600' : 'bg-amber-500/15 text-amber-600'}`}>
                  Pre-checked · {o.last_precheck.status === 'clean' ? 'all match' : `${o.last_precheck.issue_count} issue(s)`}
                </span>
              )}
            </span>
            <ChevronRight className="w-4 h-4 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
